import { preventBodyScroll } from '../core/helper-functions'

module.exports = {
  props: ['translation', 'languages'],
  data () {
    return {
      selectedLanguage: {},
      visible: false
    }
  },

  methods: {
    changeCurrency (currencyId) {
      $.ajax({
        url: "{% url 'change_currency' %}",
        method: "POST",
        data:
            {
                currencyId: currencyId,
                csrfmiddlewaretoken: '{{ csrf_token }}'
            },
        datatype: "json"
      }).done(function (data) {
        if (data.success) {
            location.reload();
        }
      });
    },

    open () {
      this.visible = true
      preventBodyScroll(true)
    },

    close () {
      this.visible = false
      preventBodyScroll(false)
    },

    reload () {
      window.location.reload()
    },
  },

  template: `
    <div class="relative">
      <div @click="open">
        <slot name="reference"></slot>
      </div>
      <transition name="fade">
        <div v-if="visible" @click="close" class="hero-modal p-md-4 text-md-left d-flex justify-content-center align-items-center">
          <div @click.stop class="overflow-y-auto h-100">
            <div class="hero-modal__language relative">
              <p @click="close" class="h-pointer hero-modal__close h-text-grey-cl-450 d-flex align-items-center">
                <i class="icon-close"></i>
              </p>
              <div class="hero-modal__language__main">
                <div class="p-3 p-md-4 rich-text text-center">
                  <h3 class="m-0 mb-2 h-text-grey-cl-900 h-font-barlow font-weight-bold">Please choose your language</h3>
                </div>
                <div class="hero-modal__language__list">
                  <a class="hero-modal__language__item" href="/en-ca" @click="changeCurrency(2)">
                    <div class="hero-modal__language__item__flag">
                      <img src="/static/personal_book_app/img/country-flags/ca-flag.png" alt="Canada - Flag" width="40">
                    </div>
                    <div class="hero-modal__language__item__wrapper">
                      <div class="rich-text hero-modal__language__item__content">
                        <span><h6 class="text-mega font-weight-bold">English (Canada)</h6></span>
                      </div>
                    </div>
                    <div class="hero-modal__language__item__arrow">
                    <i class="fas fa-caret-right"></i>
                    </div>
                  </a>
                  <a class="hero-modal__language__item" href="/fr" @click="changeCurrency(2)">
                    <div class="hero-modal__language__item__flag">
                      <img src="/static/personal_book_app/img/country-flags/ca-flag.png" alt="Canada - Flag" width="40">
                    </div>
                    <div class="hero-modal__language__item__wrapper">
                      <div class="hero-modal__language__item__content">
                        <span><h6 class="text-mega font-weight-bold">French (Canada)</h6></span>
                      </div>
                    </div>
                    <div class="hero-modal__language__item__arrow">
                      <i class="fas fa-caret-right"></i>
                    </div>
                  </a>
                  <a class="hero-modal__language__item" href="/en-us" @click="changeCurrency(1)">
                    <div class="hero-modal__language__item__flag">
                      <img src="/static/personal_book_app/img/country-flags/us-flag.png" alt="United States - Flag" width="40">
                    </div>
                    <div class="hero-modal__language__item__wrapper">
                      <div class="rich-text hero-modal__language__item__content">
                        <span>
                          <h6 class="text-mega font-weight-bold">English (US)</h6>
                        </span>
                      </div>
                    </div>
                    <div class="hero-modal__language__item__arrow">
                      <i class="fas fa-caret-right"></i>
                    </div>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </transition>
    </div>
  `
}